<script lang="ts" setup>
    import { computed } from 'vue';
    import { IPatientServicePatientHeaderResponse } from '../lib/Models/PatientModel';
import GenderIcon from './Choice/Patient/GenderIcon.vue';

    const props = defineProps<{
        patientDetail?: IPatientServicePatientHeaderResponse
    }>();

    const patientTitle = computed<string>(() => {
        if (props.patientDetail == undefined)
            return "";
        const birthAge = props.patientDetail.birthDate == "" ? "" : ` ${props.patientDetail.birthDate}(${props.patientDetail.patientAge})`;
        const genderSpace = genderExists ? " " : "";
        return `${genderSpace}${props.patientDetail.patientId}-${props.patientDetail.patientName}${birthAge}`;
    });
    const patientTooltip = computed<string>(() => {
        if (props.patientDetail == undefined)
            return "";
        return `Chart #${props.patientDetail.patientId}\r\nPatient: ${props.patientDetail.patientName}\r\nGender: ${props.patientDetail.genderDescription ?? ""}\r\nBirth Date: ${props.patientDetail.birthDate}\r\nAge: ${props.patientDetail.patientAge}`;
    });
    const genderClass = computed<string>(() => {
        if (props.patientDetail == undefined)
            return "";
        let genderClass = "";
        if (props.patientDetail.genderCode == "M")
            genderClass = "fa-solid fa-mars";
        else if (props.patientDetail.genderCode == "F")
            genderClass = "fa-solid fa-venus";
        return genderClass;
    });
    const genderExists = computed<boolean>(() => (props.patientDetail?.genderCode == "M" || props.patientDetail?.genderCode == "F") ? true : false);
</script>

<template>
    <span :title="patientTooltip">{{ patientTitle }}</span>
    <span class="ms-1">
        <GenderIcon :gender="props.patientDetail?.genderCode" />
    </span>
</template>